import type { StatusEffect } from '@common/FabulaUltimaGame';

// Generated offline from the six PNGs by sampling opaque non-white pixels in
// 32-channel buckets, then lifting the dominant color toward white.
export const statusEffectColors: Record<StatusEffect, { primary: string; light: string }> = {
  dazed: { primary: '#b09010', light: '#f4eedc' },
  enraged: { primary: '#b03010', light: '#f4e0dc' },
  poisoned: { primary: '#703090', light: '#e8dcef' },
  shaken: { primary: '#301070', light: '#e0dcef' },
  slow: { primary: '#909090', light: '#ebebeb' },
  weak: { primary: '#309010', light: '#dcefdc' },
};
